import React from 'react'
import styled from 'styled-components'
import {
  SubNavListItem,
  NavListIconWrapper,
  NavListIcon,
  SubNavListText,
  SubNavListHeading,
  SubNavListDesc,
  PageLinkWrapper,
  PageLink
} from './styled'
import { withRouter } from 'react-router-dom'
import { onClickLink } from '../common3/Link'


const Wrapper = styled.ul`
  display: ${p => p.open ? 'block' : 'none'};
  margin-top: 15px;
  margin-bottom: 0;
  padding: 0;
`

const MobileSubNav = ({ navItem, theme, index, selected, setOpen, history }) => {
  return (
    <Wrapper open={index === selected}>
      {navItem.sub.map((sub, i) => {
        if (sub.type === 'navLink') {
          return (
            // Wrap with router link to sub.url
            <SubNavListItem
              key={i}
              iconColor={theme.iconColor}
              hoverColor={theme.hoverColor}
              onClick={
                onClickLink(sub.url, history)
                // sub.url
                //   ? () => { history.push('/' + sub.url); setOpen(false) }
                //   : () => { }
              }
            >
              {sub.icon && (
                <NavListIconWrapper bgColor={theme.iconColor} mobile>
                  <NavListIcon className={`icon ${sub.icon}`} color={theme.iconColor} mobile />
                </NavListIconWrapper>
              )}
              <SubNavListText>
                <SubNavListHeading color={theme.navItemColor}>{sub.heading}</SubNavListHeading>
                {sub.desc && <SubNavListDesc color={theme.subTextColor} mobile>{sub.desc}</SubNavListDesc>}
              </SubNavListText>
            </SubNavListItem>
            // Wrap end
          )
        }

        if (sub.type === 'seeAll') {
          return (
            <PageLinkWrapper key={i}>
              {/* Wrap with router link to navItem.href */}
              <PageLink color={theme.linkColor}>{navItem.heading}</PageLink>
            </PageLinkWrapper>
          )
        }

        if (sub.type === 'separator' || sub.type === 'subHeading') {
          return ''
        }

        throw new Error(`MobileSubNav.js can't handle type "${sub.type}"`)
      })}
    </Wrapper>
  )
}

export default withRouter(MobileSubNav)